import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00f35ed9"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "video__posterContainer__play" }, null, -1))
const _hoisted_3 = { class: "video__wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "container center video__wrapper-loading"
}
const _hoisted_5 = ["id"]

import { computed, ref, Ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseVideoLink',
  props: {
    youTube: {},
    id: {}
  },
  setup(__props: any) {

const props = __props;
const modal: Ref<boolean> = ref(false);
const modalLoader: Ref<boolean> = ref(false);
const videoLinkCode = computed((): string => {
  let regexp = new RegExp('\\?v=([^&]+)(&.*)?$', 'i');

  if (props.youTube.match(regexp)) {
    return props.youTube.match(regexp)![1];
  } else {
    return '';
  }
});

const video = computed((): string => {
  return `https://www.youtube.com/embed/${videoLinkCode.value}`;
});
const imgSrc = computed((): string => {
  return `//img.youtube.com/vi/${videoLinkCode.value}/mqdefault.jpg`;
});

const openVideo = (youTube: string, id: string) => {
  modal.value = true;
  modalLoader.value = true;
  setTimeout(() => {
    const frame = `<iframe v-if="youTube" class="video__frame" style="position:absolute; left: 0; top: 0; width: 100%; height: 100%; border: 0" src="${youTube}" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;

    document.querySelector(`#${CSS.escape(id)}`)!.insertAdjacentHTML('afterbegin', frame);
    modalLoader.value = false;
  }, 1000);
};

return (_ctx: any,_cache: any) => {
  const _component_base_spinner = _resolveComponent("base-spinner")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "video__posterContainer pointer",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openVideo(video.value, _ctx.id)))
    }, [
      _createElementVNode("img", {
        src: imgSrc.value,
        alt: "",
        class: "video__posterContainer__poster"
      }, null, 8, _hoisted_1),
      _hoisted_2
    ]),
    _createVNode(_component_base_modal, {
      "show-modal": modal.value,
      "close-outside": "",
      "hide-title": "",
      onClose: _cache[1] || (_cache[1] = ($event: any) => (modal.value = false))
    }, {
      content: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (modalLoader.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(_component_base_spinner, {
                  size: 50,
                  color: "#009D3E"
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", { id: _ctx.id }, null, 8, _hoisted_5)
        ])
      ]),
      _: 1
    }, 8, ["show-modal"])
  ], 64))
}
}

})